module.exports = __webpack_public_path__ + "static/img/visual_cover.dcd9df6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/daas_case/visual_cover.jpg
// module id = TP7y
// module chunks = 0